import { addNotification as notify } from "reapop";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";
import * as DTOS from "../FeralScan.dtos";
import { 
    ADMIN_ADD_USER_TO_GRP_REQUEST, 
    ADMIN_USER_GRP_REQUEST, 
    ADMIN_APRROVE_USER_4_GRP_REQUEST, 
    AdminAction, 
    ADMIN_DEL_USER_FROM_GRP_REQUEST, 
    ADMIN_EDIT_USER_GRP_REQUEST, 
    ADMIN_EDIT_USER_REQUEST, 
    ADMIN_SEARCH_PLOTS_REQUEST, 
    ADMIN_SEARCH_USERS_REQUEST, 
    ADMIN_SEARCH_USER_GRP_REQUEST, 
    approveUserForUserGroupSuccess, 
    deleteUserFromUserGroupSuccess, 
    editUserGroupsSuccess, 
    editUserSuccess, 
    inviteUserToUserGroupSuccess, 
    searchPlotsSuccess, 
    searchUserGroupsSuccess, 
    searchUsersSuccess, 
    setAdminUserUserGroupSuccess, 
    ISearchUsersRequest, 
    ADMIN_GET_SINGLE_USER_REQUEST, 
    IGetSingleUserRequest, 
    getSingleUserSuccess, 
    ISearchPlotsRequest, 
    ADMIN_BATCH_IMPORT_REQUEST, 
    IBatchAdminImportRequest, 
    ADMIN_SEARCH_USER_ROLES_REQUEST, 
    ISearchUserRolesRequest, 
    searchUserRolesSuccess, 
    batchImportSuccess, 
    batchImportFail, 
    ADMIN_SEARCH_FILES_REQUEST, 
    ISearchFilesRequest, 
    searchFilesSuccess, 
    ADMIN_GET_PLOT_METAINFO_REQUEST, 
    IGetPlotMetaInfoRequest, 
    getPlotMetaInfoSuccess, 
    editUserFailure
} from "../actions/admin.actions";
import * as ErrorHandler from "../common/errorHandler";
import * as NotificationsActionCreators from "../common/notification";
import { serviceApi } from "../services/admin.service";


export const updateAdminMemberForUserGroup = action$ =>
    action$
        .ofType(ADMIN_USER_GRP_REQUEST)
        .mergeMap((action: AdminAction) =>
            serviceApi
                .updateAdminMemberForUserGroup(action.groupId, action.userId)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(setAdminUserUserGroupSuccess(response))
                    );
                })
                .catch(
                    (error: DTOS.AdminUpdateAdminUserGroupResponse) => ErrorHandler.FireErrorActions(error)
                )
        );

export const approveMemberforUserGroup = action$ =>
    action$
        .ofType(ADMIN_APRROVE_USER_4_GRP_REQUEST)
        .mergeMap((action: AdminAction) =>
            serviceApi
                .approveMemberForUserGroup(action.groupId, action.userId)
                .mergeMap(response => {
                    var notification = notify(NotificationsActionCreators.notifyInfo("", "Member has been approved"));
                    return concat$(
                        Observable.of(approveUserForUserGroupSuccess(response)),
                        Observable.of(notification)
                    );
                })
                .catch((error: DTOS.AdminApproveUserForGroupResponse) => ErrorHandler.FireErrorActions(error))
        );

export const deleteMemberFromUserGroup = action$ =>
    action$
        .ofType(ADMIN_DEL_USER_FROM_GRP_REQUEST)
        .mergeMap((action: AdminAction) =>
            serviceApi
                .deleteMemberFromUserGroup(action.groupId, action.userId)
                .mergeMap(response => {
                    var notification = notify(NotificationsActionCreators.notifyInfo("", "Member has been deleted"));
                    return concat$(
                        Observable.of(deleteUserFromUserGroupSuccess(response)),
                        Observable.of(notification)
                    )
                })
                .catch((error: DTOS.AdminDeleteUserFromGroupResponse) => ErrorHandler.FireErrorActions(error))
        );

export const addMemberToUserGroup = action$ =>
    action$
        .ofType(ADMIN_ADD_USER_TO_GRP_REQUEST)
        .mergeMap((action: AdminAction) =>
            serviceApi
                .addMemberToUserGroup(action.groupId, action.email, action.name)
                .mergeMap(response => {
                    var notification = notify(NotificationsActionCreators.notifyInfo("New Member", `${action.name} has been added`));
                    return concat$(
                        Observable.of(inviteUserToUserGroupSuccess(response)),
                        Observable.of(notification)
                    );
                })
                .catch((error: DTOS.AdminAddUserToGroupResponse) => ErrorHandler.FireErrorActions(error))
        );

export const editUserGroup = action$ =>
    action$
        .ofType(ADMIN_EDIT_USER_GRP_REQUEST)
        .mergeMap((action: AdminAction) =>
            serviceApi
                .editUserGroup(action.group)
                .mergeMap(response => {
                    var notification = undefined;
                    if (action.group.obsolete) {
                        notification = notify(NotificationsActionCreators.notifyWarning("", `${action.group.name} has been deleted`));
                    } else {
                        notification = notify(NotificationsActionCreators.notifyInfo("", `${action.group.name} has been saved`));
                    }
                    return concat$(
                        Observable.of(editUserGroupsSuccess(response)),
                        Observable.of(notification)
                    );
                })
                .catch((error: DTOS.AdminSaveUserGroupResponse) => ErrorHandler.FireErrorActions(error))
        );

export const editUser = action$ =>
    action$
        .ofType(ADMIN_EDIT_USER_REQUEST)
        .mergeMap((action: AdminAction) =>
            serviceApi
                .editUser(action.user)
                .mergeMap(response => {
                    /*
                    var notification = undefined;
                    if (action.user.obsolete) {
                        notification = notify(NotificationsActionCreators.notifyWarning("", `${action.user.fullName} has been deleted`));
                    } else {
                        notification = notify(NotificationsActionCreators.notifyInfo("", `${action.user.fullName} has been saved`));
                    }*/
                    return concat$(
                        Observable.of(editUserSuccess(response))
                    );
                })
                .catch(error => {
                    return concat$(
                        ErrorHandler.FireErrorActions(error)
                        , Observable.of(editUserFailure())
                    )
                })
        );

export const getSingleUser = action$ =>
    action$
        .ofType(ADMIN_GET_SINGLE_USER_REQUEST)
        .mergeMap((action: IGetSingleUserRequest) =>
            serviceApi
                .searchUsers(action.userId, undefined, undefined)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(getSingleUserSuccess(response))
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
        );

export const searchUsers = action$ =>
    action$
        .ofType(ADMIN_SEARCH_USERS_REQUEST)
        .mergeMap((action: ISearchUsersRequest) =>
            serviceApi
                .searchUsers(undefined, action.searchText, action.includeObsolete)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(searchUsersSuccess(response))
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
        );

export const searchUserRoles = action$ =>
    action$
        .ofType(ADMIN_SEARCH_USER_ROLES_REQUEST)
        .mergeMap((action: ISearchUserRolesRequest) =>
            serviceApi
                .searchUserRoles(action.userId, action.plotId)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(searchUserRolesSuccess(response))
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
        );

export const searchUserGroups = action$ =>
    action$
        .ofType(ADMIN_SEARCH_USER_GRP_REQUEST)
        .mergeMap((action: AdminAction) =>
            serviceApi
                .searchUserGroups(action.text)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(searchUserGroupsSuccess(response))
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
        );

export const searchPlots = action$ =>
    action$
        .ofType(ADMIN_SEARCH_PLOTS_REQUEST)
        .mergeMap((action: ISearchPlotsRequest) =>
            serviceApi
                .searchPlots(undefined, action.searchText, action.includeObsolete)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(searchPlotsSuccess(response))
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
        );

export const getPlotMetaInfo = action$ =>
    action$
        .ofType(ADMIN_GET_PLOT_METAINFO_REQUEST)
        .mergeMap((action: IGetPlotMetaInfoRequest) =>
            serviceApi
                .getPlotMetaInfo()
                .mergeMap(response => {
                    return concat$(
                        Observable.of(getPlotMetaInfoSuccess(response))
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
        );

export const searchFiles = action$ =>
    action$
        .ofType(ADMIN_SEARCH_FILES_REQUEST)
        .mergeMap((action: ISearchFilesRequest) =>
            serviceApi
                .searchFiles(undefined, action.searchText)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(searchFilesSuccess(response))
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
        );

export const batchImport = action$ =>
    action$
        .ofType(ADMIN_BATCH_IMPORT_REQUEST)
        .mergeMap((action: IBatchAdminImportRequest) =>
            serviceApi
                .batchAdminImportPlotEvents(action.files, action.plotId, action.userId)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(batchImportSuccess(response))
                    )
                })
                .catch((error) => {
                    return concat$(
                        ErrorHandler.FireErrorActions(error)
                        , Observable.of(batchImportFail(error))
                    )
                })
        );